import { useCallback, useMemo } from 'react';
import {
	ToothPathology,
	ToothPathologyApicalValues,
	ToothSurface,
} from '../../../../../graphql/graphql';
import { SurfaceOperation } from '../../../Enums/SurfaceOperation.enum';
import { handleSurfacesOperation } from '../../../Helpers/surfaces/toothSurfaces.helper';

export default function useToothPathologyApical({
	pathology,
	setPathology,
}: {
	pathology?: ToothPathology;
	setPathology: (pathology: ToothPathology) => void;
}) {
	const setSurfaces = useCallback(
		(surfaces: ToothSurface[], operation: SurfaceOperation) => {
			setPathology({
				...pathology,
				apical: {
					...pathology?.apical,
					values: pathology?.apical?.values ?? {},
					surfaces: handleSurfacesOperation(
						pathology?.apical?.surfaces ?? [],
						surfaces,
						operation,
					),
				},
			});
		},
		[pathology, setPathology],
	);

	const setValues = useCallback(
		(values: ToothPathologyApicalValues) => {
			setPathology({
				...pathology,
				apical: {
					...pathology?.apical,
					surfaces: pathology?.apical?.surfaces ?? [],
					values,
				},
			});
		},
		[pathology, setPathology],
	);

	return useMemo(
		() => ({
			apical: {
				surfaces: pathology?.apical?.surfaces ?? [],
				setSurfaces: setSurfaces,
				values: pathology?.apical?.values,
				setValues: setValues,
			},
		}),
		[pathology],
	);
}
